import {
    ChangeDetectionStrategy,
    Component,
    computed,
    effect,
    inject,
    input,
    signal,
} from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { SvgLoaderService } from '../../../core/services/svg-loader.service';

@Component({
    selector: 'app-svg-icon',
    template: `<span class="svg-icon__inner" [innerHTML]="safeSvg()"></span>`,
    styles: [
        `
            :host {
                display: inline-flex;
                align-items: center;
                justify-content: center;
                width: var(--svg-icon-size, 1em);
                height: var(--svg-icon-size, 1em);
                color: inherit;
                line-height: 0;
            }
            .svg-icon__inner {
                display: inline-flex;
                width: 100%;
                height: 100%;
            }
            :host ::ng-deep svg {
                width: 100%;
                height: 100%;
                display: block;
            }
        `,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SvgIcon {
    private readonly loader = inject(SvgLoaderService);
    private readonly sanitizer = inject(DomSanitizer);

    readonly name = input.required<string>();
    readonly folder = input<string>('svg');

    private readonly rawSvg = signal<string>('');
    readonly safeSvg = computed<SafeHtml>(() =>
        this.sanitizer.bypassSecurityTrustHtml(this.rawSvg()),
    );

    constructor() {
        effect((onCleanup) => {
            const path = `/${this.folder()}/${this.name()}.svg`;
            const sub = this.loader.load(path).subscribe({
                next: (svg) => this.rawSvg.set(svg),
                error: () => this.rawSvg.set(''),
            });
            onCleanup(() => sub.unsubscribe());
        });
    }
}
